import dateTimeWrapper from "../../dateTimeWrapper";

const getTimestamp = () => {
  const date = dateTimeWrapper();
  const dateString = date.toString();
  const timeZoneOffset = dateString.substr(dateString.indexOf("GMT"), 8);
  const [, year, month, day, hours, minutes] = date
    .toISOString()
    .match(/(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/);

  return `${day}/${month}/${year} ${hours}:${minutes} ${timeZoneOffset}`;
};

export default getTimestamp;
